// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__7hqOx","amount":"Amount_amount__2EjAp","tip":"Amount_tip__5V14P","tipHeader":"Amount_tipHeader__2uQyk","tipsWrap":"Amount_tipsWrap__2tOai"};